import { __decorate } from "tslib";
import { LitElement, html, customElement, internalProperty } from 'lit-element';
import { sortList } from './utils';
let DemoSwappableRows = class DemoSwappableRows extends LitElement {
    constructor() {
        super(...arguments);
        this.listOne = [
            { id: '1' },
            { id: '2' },
            { id: '3' }
        ];
        this.listTwo = [
            { id: '4' },
            { id: '5' },
            { id: '6' }
        ];
    }
    render() {
        return html `
      <cds-grid @draggableChange=${this.sortOne}>
        <cds-grid-column width="45"></cds-grid-column>
        <cds-grid-column>id</cds-grid-column>
        <cds-grid-column>description</cds-grid-column>

        ${this.listOne.map(entry => html `
          <cds-grid-row id=${entry.id} draggable="true">
            <cds-grid-cell>
              <cds-inline-button drag-handle>
                <cds-icon shape="drag-handle"></cds-icon>
              </cds-inline-button>
            </cds-grid-cell>
            <cds-grid-cell>${entry.id}</cds-grid-cell>
            <cds-grid-cell>...</cds-grid-cell>
          </cds-grid-row>
        `)}
        <cds-grid-placeholder draggable="false">
          Move a row to the second grid.
        </cds-grid-placeholder>
        <cds-grid-footer>
          List One: ${this.listOne.map(i => html `${i.id} `)}
        </cds-grid-footer>
      </cds-grid>

      <br /><br />

      <cds-grid @draggableChange=${this.sortTwo}>
        <cds-grid-column width="50"></cds-grid-column>    
        <cds-grid-column>id</cds-grid-column>
        <cds-grid-column>description</cds-grid-column>

        ${this.listTwo.map(entry => html `
          <cds-grid-row id=${entry.id} draggable="true">
            <cds-grid-cell>
              <cds-inline-button drag-handle>
                <cds-icon shape="drag-handle"></cds-icon>
              </cds-inline-button>
            </cds-grid-cell>
            <cds-grid-cell>${entry.id}</cds-grid-cell>
            <cds-grid-cell>...</cds-grid-cell>
          </cds-grid-row>
        `)}
        <cds-grid-placeholder draggable="false">
          Move a row to the first grid.
        </cds-grid-placeholder>
        <cds-grid-footer>
          List Two: ${this.listTwo.map((j, i) => html `${j.id} `)}
        </cds-grid-footer>
      </cds-grid>
    `;
    }
    sortOne(e) {
        if (this.listOne.find(i => i.id === e.detail.from.id)) {
            this.listOne = sortList(e.detail.target, e.detail.from, this.listOne);
        }
        else {
            const { fromList, targetList } = this.swap(this.listOne, this.listTwo, e.detail);
            this.listOne = targetList;
            this.listTwo = fromList;
        }
    }
    sortTwo(e) {
        if (this.listTwo.find(i => i.id === e.detail.from.id)) {
            this.listTwo = sortList(e.detail.target, e.detail.from, this.listTwo);
        }
        else {
            const { fromList, targetList } = this.swap(this.listTwo, this.listOne, e.detail);
            this.listTwo = targetList;
            this.listOne = fromList;
        }
    }
    swap(targetList, fromList, detail) {
        const item = fromList.splice(fromList.indexOf(fromList.find(i => i.id === detail.from.id)), 1)[0];
        const targetIndex = targetList.indexOf(targetList.find(i => i.id === detail.target.id));
        targetIndex === -1 ? targetList.push(item) : targetList.splice(targetIndex, 0, item);
        return { targetList: [...targetList], fromList: [...fromList] };
    }
    createRenderRoot() {
        return this;
    }
};
__decorate([
    internalProperty()
], DemoSwappableRows.prototype, "listOne", void 0);
__decorate([
    internalProperty()
], DemoSwappableRows.prototype, "listTwo", void 0);
DemoSwappableRows = __decorate([
    customElement('demo-swappable-rows')
], DemoSwappableRows);
export { DemoSwappableRows };
//# sourceMappingURL=demo.row-swappable.js.map